import { render, staticRenderFns } from "./MemoryHistoryTable.vue?vue&type=template&id=79b28084&scoped=true"
import script from "./MemoryHistoryTable.vue?vue&type=script&lang=js"
export * from "./MemoryHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./MemoryHistoryTable.vue?vue&type=style&index=0&id=79b28084&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b28084",
  null
  
)

export default component.exports